import { InstallationSmartLockStatus } from "@/model/data/oneTimeCode/InstallationSmartLockStatus";
import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../ApiGenericResponse";

export class ActivateSmartLockResData extends ApiGenericResponse {
    installation: InstallationSmartLockStatus;

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.Installation) {
            this.installation = new InstallationSmartLockStatus();
            this.installation.parse(obj.Installation);
        }
    }
}
